import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function ResetPassword({show, onClose, onSwitchToLogin}) {

    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();

    const clearFields = () => {
        setPassword('');
    };
    const handleClose = () => {
        clearFields();
        localStorage.removeItem('resetToken');
        localStorage.removeItem('resetUserId');
        onClose();
    };
    axios.defaults.withCredentials = true;
    const handleSubmit = (e) => {
        e.preventDefault();

        if(!password){
            setErrorMessage('Please fill all fields');
            return;
        }

        const token = localStorage.getItem("resetToken");
        const userId = localStorage.getItem("resetUserId");

        axios.post('http://localhost:3001/reset-password', {
            id: userId,
            token,
            password
        })
        .then(result => {
            console.log(result);
            if(result.data === "Success") {
                setSuccessMessage('Password reset successfully! Redirecting to login...');
                setErrorMessage('');
                clearFields();
                setTimeout(() => {
                    localStorage.removeItem("resetToken");
                    localStorage.removeItem("resetUserId");
                    clearFields();
                    onClose();
                    onSwitchToLogin();
                }, 2000);
            }
        })
        .catch(err => {
            console.log(err);
            setErrorMessage('Failed to reset password. The link may have expired.');
        })
    };

    useEffect(() => {
        // Check if there's a reset token in localStorage when component mounts
        const token = localStorage.getItem('resetToken');
        const userId = localStorage.getItem('resetUserId');

        if(token && userId && !show) {
            // Verify the token is still valid
            axios.post('http://localhost:3001/verify-reset-token', {
                id: userId,
                token
            })
            .then(response => {
                if(response.data.valid) {
                    // Token is valid, show the modal
                    window.dispatchEvent(new CustomEvent("showResetPassword"));
                } else {
                    localStorage.removeItem('resetToken');
                    localStorage.removeItem('resetUserId');
                }
            })
            .catch(err => {
                console.error('error in reset password use effect',err);
                localStorage.removeItem('resetToken');
                localStorage.removeItem('resetUserId');
            })
        }
    }, [show])


    return (
        <div className="auth-modal-overlay" style={{ display: show ? 'flex' : 'none' }}>
          <div className="auth-modal-content">
            <span className="auth-close-btn" onClick={handleClose}>&times;</span>
            <h2 className="auth-modal-title">TATA CLiQ FASHION</h2>
    
            <div className='bg-white p-3 rounded w-250'>
                    <h2>Reset Password</h2>
                    {errorMessage && <div className='alert alert-danger'>{errorMessage}</div>}
                    {successMessage && <div className='alert alert-success'>{successMessage}</div>}
                        <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label ><strong>Password</strong></label>
                                    <input type="password" 
                                    value={password}
                                    className='form-control rounded-0'
                                    onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>
                                <button type='submit' className='btn btn-success w-100 rounded-0'>Reset Password</button>
                        </form>
            </div>
          </div>
        </div>
      )
}

export default ResetPassword